import React from "react";
import { FormattedMessage } from "react-intl";
import styles from "./countryDescription.module.scss";
import { RichText } from "prismic-reactjs";
import htmlSerializer from "@utils/htmlSerializer/htmlSerializer";
import "lazysizes";
import Imgix, { buildURL } from "react-imgix";

const CountryDescription = ({
  countryName,
  capitalCity,
  currencySymbol,
  currencyCode,
  callingCode,
  countryDescription,
  countryFlag,
  countryFooter,
}) => (
  <div className={styles.countryDescriptionWrapper}>
    <h1 className={styles.countryDescriptionWrapper__title}>
      <span>
        <FormattedMessage id="countries_page.country_wrapper.hello" />
      </span>
      {countryName}
    </h1>
    <div className={styles.countryDescriptionWrapper__content}>
      <div className={styles.countryDescriptionWrapper__content__text}>
        {countryDescription && (
          <RichText
            render={countryDescription}
            htmlSerializer={htmlSerializer}
          />
        )}
        {countryFooter && (
          <RichText render={countryFooter} htmlSerializer={htmlSerializer} />
        )}
      </div>
      <div className={styles.countryDescriptionWrapper__content__attributes}>
        <div
          className={
            styles.countryDescriptionWrapper__content__attributes__leftBlock
          }
        >
          <div
            className={
              styles.countryDescriptionWrapper__content__attributes__leftBlock__key
            }
          >
            <p>
              <FormattedMessage id="global.country.capital_city" />
            </p>
            <p>
              <FormattedMessage id="global.country.currency" />
            </p>
            <p>
              <FormattedMessage id="global.country.calling_code" />
            </p>
          </div>
          <div
            className={
              styles.countryDescriptionWrapper__content__attributes__leftBlock__value
            }
          >
            <p>{capitalCity}</p>
            <p>
              {currencySymbol} <span>({currencyCode})</span>
            </p>
            <p>{callingCode}</p>
          </div>
        </div>
        <div
          className={
            styles.countryDescriptionWrapper__content__attributes__rightBlock
          }
        >
          <Imgix
            className="lazyload"
            src={countryFlag.url}
            alt={countryFlag.alt ? countryFlag.alt : countryName}
            width={30}
            imgixParams={{ auto: 'compress,format' }}
            attributeConfig={{
              src: 'data-src',
              srcSet: 'data-srcset',
              sizes: 'data-sizes',
            }}
            htmlAttributes={{
              src: buildURL(countryFlag.url, { auto: 'compress,format', blur: 50, w: 30 }),
            }}
          />
        </div>
      </div>
    </div>
  </div>
);

export default CountryDescription;
